import React, { useState } from 'react';
import '../App.css';

function LEDControl({ bluetoothDevice, usbPort, sendCommand }) {
  const [ledOn, setLedOn] = useState(false);
  const [selectedColor, setSelectedColor] = useState('white');
  const [brightness, setBrightness] = useState(150);

  const colors = [
    { name: 'white', label: 'White' },
    { name: 'red', label: 'Red' },
    { name: 'green', label: 'Green' },
    { name: 'blue', label: 'Blue' },
    { name: 'yellow', label: 'Yellow' },
    { name: 'orange', label: 'Orange' },
    { name: 'purple', label: 'Purple' },
    { name: 'cyan', label: 'Cyan' },
    { name: 'pink', label: 'Pink' }
  ];

  const toggleLED = async () => {
    // Logic handled by sendCommand, but check connection for UI feedback if needed
    const newState = !ledOn;
    setLedOn(newState);
    await sendCommand(newState ? 'led on' : 'led off');
  };

  const changeColor = async (color) => {
    setSelectedColor(color);
    await sendCommand(`led ${color}`);
    if (!ledOn) {
      setLedOn(true);
      await sendCommand('led on');
    }
  };

  // Debounce brightness changes
  React.useEffect(() => {
    const handler = setTimeout(() => {
      // Only send if connected
      if (bluetoothDevice?.gatt?.connected || usbPort) {
        sendCommand(`led brightness ${brightness}`);
      }
    }, 200);

    return () => {
      clearTimeout(handler);
    };
  }, [brightness, bluetoothDevice, usbPort]); // Dep depends on brightness

  const changeBrightness = (value) => {
    setBrightness(value);
    // Command sent via useEffect/debounce
  };

  return (
    <div className="card">
      <h2>💡 LED Control</h2>

      <div className="input-group">
        <label>Power</label>
        <button
          className={`button ${ledOn ? 'danger' : 'success'}`}
          onClick={toggleLED}
          style={{ width: '100%' }}
        >
          {ledOn ? 'Turn OFF' : 'Turn ON'}
        </button>
      </div>

      <div className="input-group">
        <label>Color</label>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px', marginTop: '10px' }}>
          {colors.map(color => (
            <button
              key={color.name}
              className="button"
              onClick={() => changeColor(color.name)}
              style={{
                backgroundColor: selectedColor === color.name
                  ? 'rgba(255, 255, 255, 0.3)'
                  : 'rgba(255, 255, 255, 0.1)',
                border: selectedColor === color.name ? '2px solid white' : '1px solid rgba(255, 255, 255, 0.2)'
              }}
            >
              {color.label}
            </button>
          ))}
        </div>
      </div>

      <div className="input-group">
        <label>Brightness: {brightness}</label>
        <input
          type="range"
          min="0"
          max="255"
          value={brightness}
          onChange={(e) => changeBrightness(parseInt(e.target.value))}
          className="slider"
        />
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8em', opacity: 0.7 }}>
          <span>0</span>
          <span>255</span>
        </div>
      </div>

      <div style={{ marginTop: '20px', padding: '15px', background: 'rgba(0, 0, 0, 0.2)', borderRadius: '10px' }}>
        <div style={{
          width: '100%',
          height: '60px',
          background: ledOn
            ? `linear-gradient(to right, ${selectedColor === 'red' ? '#ff0000' : selectedColor === 'green' ? '#00ff00' : selectedColor === 'blue' ? '#0000ff' : selectedColor === 'yellow' ? '#ffff00' : selectedColor === 'orange' ? '#ff8000' : selectedColor === 'purple' ? '#8000ff' : selectedColor === 'cyan' ? '#00ffff' : selectedColor === 'pink' ? '#ff00ff' : '#ffffff'}, rgba(255,255,255,0.3))`
            : '#000',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '1.2em',
          fontWeight: 'bold',
          opacity: ledOn ? brightness / 255 : 0.3,
          transition: 'all 0.3s ease'
        }}>
          {ledOn ? 'LED ON' : 'LED OFF'}
        </div>
      </div>
    </div>
  );
}

export default LEDControl;
